import { User } from '@uplift/types';
import { restClient } from '../client';


export type CheckProviderInviteLinkInput = {
  invite_token: string;
};

export type CheckProviderInviteLinkOutput = {
  error?: string;
  user?: User;
};

export const checkProviderInviteLink = restClient.createRequest<CheckProviderInviteLinkInput, CheckProviderInviteLinkOutput>({
  url: '/auth/check_provider_invite_link',
  method: 'POST',
});
